import React from "react";
import { Scale } from "lucide-react";

const AUTH_BG = "https://images.unsplash.com/photo-1505664194779-8beaceb93744?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxsYXclMjBsaWJyYXJ5JTIwYmFja2dyb3VuZHxlbnwwfHx8fDE3ODY4OTE0NDh8MA&ixlib=rb-4.1.0&q=85";

export default function AuthShell({ children, title, subtitle }) {
  return (
    <div className="flex min-h-screen">
      {/* Left: form */}
      <div className="flex w-full flex-col justify-center px-6 py-10 sm:px-12 lg:w-[46%] lg:px-16">
        <div className="mx-auto w-full max-w-md">
          <div className="mb-8 flex items-center gap-3">
            <div className="flex h-11 w-11 items-center justify-center rounded-md bg-navy text-gold">
              <Scale className="h-6 w-6" strokeWidth={1.75} />
            </div>
            <div>
              <p className="font-display text-2xl leading-none tracking-tight text-navy">Advocate Diary</p>
              <p className="text-xs text-muted-foreground">Legal practice management</p>
            </div>
          </div>
          <h1 className="font-display text-4xl tracking-tight text-navy">{title}</h1>
          {subtitle && <p className="mt-2 text-sm text-muted-foreground">{subtitle}</p>}
          <div className="mt-8">{children}</div>
        </div>
      </div>

      {/* Right: image */}
      <div className="relative hidden lg:block lg:w-[54%]">
        <img src={AUTH_BG} alt="Law library" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-navy/70" />
        <div className="absolute inset-0 flex flex-col justify-end p-16">
          <blockquote className="max-w-lg">
            <p className="font-display text-3xl leading-snug text-white">
              “The good lawyer is not the man who has an eye to every side and angle of contingency, but who throws himself on your part so heartily.”
            </p>
            <footer className="mt-4 text-sm text-gold">— Ralph Waldo Emerson</footer>
          </blockquote>
        </div>
      </div>
    </div>
  );
}
